import TiptapColor from '@tiptap/extension-color';

export const Color = TiptapColor.extend({
  // Disable paste rules for the color extension to avoid pasting colors
  // that closely resemble the default. Preserving the default color
  // keeps the markdown cleaner and makes it easier to search.
  addPasteRules() {
    return [];
  },
});
